import React from 'react'

function Hero() {
  return (
<section className="hero">
    <div className="container">
        <h1 className="text-center">
            Crazy Monkey Slot – en sosial underholdningsopplevelse med spilleautomattema
        </h1>
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/1_(2).jpg" alt="Crazy Monkey Slot Hero Image"/>
            </div>
            <div className="right-col">
                <p className="hero-text text">
                    Dette underholdningsspillet gir deg muligheten til å nyte en digital spillopplevelse i et sosialt miljø. Spillet er designet for både mobile enheter og datamaskiner, og er tilgjengelig på iOS og Android, slik at du kan spille når og hvor det passer deg.
                </p>
            </div>
        </div>
        <p className="hero-text text text-md">
            Fra første stund vil du oppleve en fargerik og engasjerende atmosfære. Levende grafikk og dynamiske lydeffekter skaper en underholdende spillopplevelse. Med symboler som gullmynter, lanterner og frukter byr Crazy Monkey Slot på en morsom og avslappende spillopplevelse. Bli en del av vårt sosiale fellesskap og nyt spillets interaktive funksjoner.
        </p>
    </div>
</section>

  )
}

export default Hero